/** Enum-like values and limits owned by the orders (Order Writer) module. */
import { ACTION } from '@daka/core';

/** Stable module id — `organization_modules.moduleId`, host registries, route prefix. */
export const ORDERS_MODULE_ID = 'orders';

/** What roles can be granted on this module (the permission resource is `ORDERS_MODULE_ID`). */
export const ORDER_ACTION = {
   READ: ACTION.READ,
   CREATE: ACTION.CREATE,
   UPDATE: ACTION.UPDATE,
   DELETE: ACTION.DELETE
} as const;
